import React, { useEffect, useState, useRef } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Carousel } from "primereact/carousel";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-purple/theme.css";
import "primeicons/primeicons.css";
import "./MainComponent.css";
import eonBeastsIcon from "./eon_beasts-icon.png";
import eonBeastsIconMoving from "./eon-beasts-icon-moving.gif";
import eonBeastsIconVideo from  "./eon-beast-icon-lightning.mp4"
import bullModelVideo from "./bull-model-vid.mp4";
import bullModelPoster from "./bull-model-poster.png"
import mainBackgroundMobile from "./main-background-mobile.png";
import bullImage from "./bull.gif";
import bearImage from "./bear.gif";
import catImage from "./cat.gif";
import birdImage from "./bird.gif";
import dogImage from "./dog.gif";

import bullVideo from "./bull.mp4"
import bearVideo from "./bear.mp4"
import catVideo from "./cat.mp4"
import birdVideo from "./bird.mp4"
import dogVideo from "./dog.mp4"

import brainIcon from "./brain.gif";
import marketplaceImage from "./marketplace.png";
import mintImage from "./chip.png";
import communityImage from "./community.png";

import evolutionImage from "./dnahelix.gif";
import rareSword from "./sword.gif";
import trophyImage from "./trophy.png";
import { Rating } from "primereact/rating";
import { SpeedDial } from "primereact/speeddial";

import SpinningCard from "../SpinningComponent/SpinningComponent";
import eonBeastWithBackground from "./eon-beasts.png";

import commonGradeBear from "./common-grade-bear.gif";
import epicGradeBear from "./epic-grade-bear.png";
import rareGradeBear from "./rare-grade-bear.png";
import legendGradeBear from "./legend-grade-bear.png";
import supremeGradeBear from "./supreme-grade-bear.png";
import readTheDocsImage from "./read-the-docs.gif";
import tokenomics from "./tokenomics.png";
import { Button } from "primereact/button";

import Tokenomics  from "../TokenomicsComponent/TokenomicsComponent";
import { Sidebar } from "primereact/sidebar";
import Roadmap from "../RoadmapComponent/RoadmapComponent";
import MenuOverlay from "../MenuOverlayComponent/MenuOverlay"; // adjust the path as needed
import LoadingCanvas from "../LoadingComponent/LoadingCanvas"; // adjust the path as needed

import urlConfig from "../../urlConfig";
export function useIsVisible(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasBeenVisible) {
        setIntersecting(true);
        setHasBeenVisible(true); // Prevent animation re-trigger
      }
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current);
      observer.disconnect();
    };
  }, [ref, hasBeenVisible]);

  return hasBeenVisible; // Use `hasBeenVisible` instead of `isIntersecting` for the animation trigger.
}
const ASSETS = {
  images: [
    eonBeastsIcon,
    eonBeastsIconMoving,
    mainBackgroundMobile,
    bullImage,
    bearImage,
    catImage,
    birdImage,
    dogImage,
    brainIcon,
    marketplaceImage,
    mintImage,
    communityImage,
    evolutionImage,
    rareSword,
    trophyImage,
    eonBeastWithBackground,
    commonGradeBear,
    epicGradeBear,
    rareGradeBear,
    legendGradeBear,
    supremeGradeBear,
    readTheDocsImage,
    tokenomics,
    bullModelPoster,
  ],
  videos: [
    eonBeastsIconVideo,
    bullModelVideo,
    bullVideo,
    bearVideo,
    catVideo,
    birdVideo,
    dogVideo,
  ],
};
function preloadImage(src, onProgress) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      onProgress();
      resolve();
    };
    img.onerror = () => {
      onProgress();
      resolve(); // don’t deadlock loader
    };
    img.src = src;
  });
}
function preloadVideo(src, onProgress) {
  return new Promise((resolve) => {
    const video = document.createElement("video");

    video.preload = "auto";
    video.muted = true;
    video.playsInline = true;

    const done = () => {
      onProgress();
      cleanup();
      resolve();
    };

    const cleanup = () => {
      video.removeEventListener("loadeddata", done);
      video.removeEventListener("error", done);
    };

    video.addEventListener("loadeddata", done);
    video.addEventListener("error", done);

    video.src = src;
    video.load();
  });
}



const MainComponent = () => {
  const [loading, setLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadProgress, setLoadProgress] = useState(0);

  const lastProgressRef = useRef(loadProgress);
  const watchdogRef = useRef(null);

  useEffect(() => {
    // Do nothing once loading is complete or invalid
    if (loadProgress >= 1) {
      if (watchdogRef.current) {
        clearTimeout(watchdogRef.current);
        watchdogRef.current = null;
      }
      return;
    }

    // Progress moved forward → reset watchdog
    if (loadProgress > lastProgressRef.current) {
      lastProgressRef.current = loadProgress;

      if (watchdogRef.current) {
        clearTimeout(watchdogRef.current);
      }

      watchdogRef.current = setTimeout(() => {
        console.warn("Progress hangs, reloading page");
        window.location.reload();
      }, 10000);
    }
  }, [loadProgress]);



  useEffect(() => {
    let loaded = 0;
    const total =
      ASSETS.images.length + ASSETS.videos.length;

    const tick = () => {
      loaded++;
      setLoadProgress(loaded / total);
    };

    async function loadAllAssets() {
      await Promise.all([
        ...ASSETS.images.map((src) =>
          preloadImage(src, tick)
        ),
        ...ASSETS.videos.map((src) =>
          preloadVideo(src, tick)
        ),
      ]);

    }

    loadAllAssets();
  }, []);

  const [menuVisible, setMenuVisible] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(mainBackgroundMobile);
  const [tokenomicsVisible, setTokenomicsVisible] = useState(false);
  const [roadmapVisible, setRoadmapVisible] = useState(false);
  const ref1 = useRef();
  const isVisible1 = useIsVisible(ref1);
  const ref2 = useRef();
  const isVisible2 = useIsVisible(ref2);
  const ref3 = useRef();
  const isVisible3 = useIsVisible(ref3);
  const ref4 = useRef()
  const isVisible4 =useIsVisible(ref4);

  const [activeGrade, setActiveGrade] = useState("Common Grade"); // Default active is "Common"
  const [rarityImage, setRarityImage] = useState(commonGradeBear);

  const grades = [
    {
      label: "Common Grade",
      color: "shadow-yellow-600",
      image: commonGradeBear,
    },
    { label: "Elite Grade", color: "shadow-green-500", image: epicGradeBear },
    { label: "Rare Grade", color: "shadow-blue-600", image: rareGradeBear },
    {
      label: "Legend Grade",
      color: "shadow-purple-600",
      image: legendGradeBear,
    },
    {
      label: "Supreme Grade",
      color: "shadow-red-600",
      image: supremeGradeBear,
    },
  ];

  const gradeClasses = {
    "Common Grade": "text-yellow-400",
    "Elite Grade": "text-green-400",
    "Rare Grade": "text-blue-400",
    "Legend Grade": "text-purple-400",
    "Supreme Grade": "text-red-500",
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 640) {
        setBackgroundImage(mainBackgroundMobile);
      } else {
        setBackgroundImage(mainBackgroundMobile);
      }
    };

    // Initial check
    handleResize();

    // Add resize listener
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const models = [
    {
      name: "Bulky Bull",
      advantage: "High damage melee tank",
      image: bullImage,
      video: bullVideo,
    }
    ,
    {
      name: "Brutal Bear",
      advantage: "Burst Damage Melee power",
      image: bearImage,
      video: bearVideo
    },
    {
      name: "Power Bird",
      advantage: "Long-range burst attacks",
      image: birdImage,
      video: birdVideo
    },
    {
      name: "Stealthy Cat",
      advantage: "Evasion and critical strikes",
      image: catImage,
      video: catVideo
    },
    {
      name: "Speedy Dog",
      advantage: "Rapid long range attacks",
      image: dogImage,
      video: dogVideo
    }
  ];

  const responsiveOptions = [
    { breakpoint: "1024px", numVisible: 3, numScroll: 1 },
    { breakpoint: "768px", numVisible: 2, numScroll: 1 },
    { breakpoint: "560px", numVisible: 1, numScroll: 1 },
  ];

const modelTemplate = (model) => (
  <div className="p-6 shadow-md bg-white bg-opacity-90 flex flex-col h-full">
    
<div className="relative w-full aspect-[1/1] overflow-hidden rounded-lg mb-4">
      <video
        autoPlay
        loop
        muted
        playsInline
        poster={model.image}
        className="absolute inset-0 w-full h-full object-contain"
      >
        <source src={model.video? model.video : ""} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-black/10"></div>
    </div>

    <div className="flex-grow flex flex-col">
      <h3 className="text-xl font-bold mb-2 text-gray-800">
        {model.name}
      </h3>
      <p className="text-gray-700">
        {model.advantage}
      </p>
    </div>

    <Rating value={3} stars={3} readOnly cancel={false} className="mt-5" />
  </div>
);


  const items = [
    {
      icon: "pi pi-times", // Telegram logo
      command: () => window.open("https://t.me/yourchannel", "_blank"),
    },
    {
      icon: "pi pi-times", // Discord logo
      command: () =>
        window.open("https://discord.com/invite/yourserver", "_blank"),
    },
    {
      icon: "pi pi-times", // Twitter/X logo
      command: () => window.open("https://twitter.com/yourprofile", "_blank"),
    },
  ];

  return (
    <>
    {/* Loader Overlay */}
    {loading && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 9999, // ensure overlay stays on top
        }}
      >
        <LoadingCanvas onComplete={() => setLoading(false)} progress={loadProgress} onCompleteSpin={()=>{setInitialLoading(false)}} imageSrc={eonBeastsIconVideo} />
      </div>
    )}

    {initialLoading && (      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 9998, // ensure overlay stays on top
          backgroundColor: "rgba(0, 0, 0)", // semi-transparent black overlay
        }}
      >
      </div>)}

    <div>
       <MenuOverlay visible={menuVisible} onClose={() => setMenuVisible(false)} />
      <Sidebar visible={tokenomicsVisible} position="top" onHide={() => setTokenomicsVisible(false)} style={{width: '100%', height: '100%', backgroundColor: 'white'}}>
    <Tokenomics />
      </Sidebar>
      <Sidebar visible={roadmapVisible} position="top" onHide={() => setRoadmapVisible(false)} style={{width: '100%', height: '100%', backgroundColor: 'white'}}>
    <Roadmap />
      </Sidebar>
<div
  className="bg-cover bg-center text-white min-h-screen flex flex-col"
  style={{ backgroundImage: `url(${backgroundImage})` }}
>
  {/* Header */}
  <div className="flex items-center justify-between w-full px-6 py-6 z-10">
    <button
      onClick={() => setMenuVisible(true)}
      className="animated-button lg:ml-36 py-2 px-4 rounded text-white text-base sm:text-lg md:text-xl lg:text-2xl font-extrabold"
    >
      <i className="pi pi-spin pi-cog mr-4"></i>
      Menu
    </button>

    <button
      onClick={() => {
        window.location.href = urlConfig.buyEon;
      }}
      className="animated-button hidden md:block mr-36 py-2 px-4 rounded text-white text-base sm:text-lg md:text-xl lg:text-2xl font-extrabold"
    >
      Buy $EON
    </button>
  </div>

  {/* HERO (icon + text) */}
  <div className="flex flex-grow items-center justify-center -translate-y-12 sm:-translate-y-16 md:-translate-y-20">
<div className="flex flex-col items-center text-center -translate-y-12 sm:translate-y-0">
  <img
    src={eonBeastsIcon}
    alt="Eon Beasts Icon"
    className="sm:block w-48 h-auto mb-6 dancing-text"
  />

  <h2
    ref={ref1}
    className={`max-w-5xl px-6
      text-4xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl
      font-extrabold transition-all duration-700
      sm:drop-shadow-[4px_6px_0px_black]
      drop-shadow-[2px_4px_0px_black]
      ${
        isVisible1
          ? "animate-fade-in-up opacity-100"
          : "opacity-0"
      }`}
  >
    Reinventing NFTs with AI Agents
  </h2>
</div>

  </div>
</div>


      {/* New Section: Reinforcement Learning with NFTs */}
<div
  style={{ backgroundColor: "#110921", position: "relative" }}
  className="text-white"
>
  <div className="grid grid-cols-1 md:grid-cols-2 w-full min-h-[1500px] md:min-h-[1200px]">
    
    {/* VIDEO COLUMN */}
    <div className="relative w-full h-full overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        poster={bullModelPoster}
      >
        <source src={bullModelVideo} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-black/15"></div>
    </div>

    {/* TEXT COLUMN */}
    <div className="flex flex-col justify-center px-6 md:px-12 py-10 md:py-0 h-full">

      <h2
        ref={ref4}
        className={`text-4xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold mb-4 transition-all duration-700 sm:drop-shadow-[5px_8px_0px_black] drop-shadow-[3px_5px_0px_black] ${
          isVisible4 ? "animate-fade-in-up opacity-100" : "opacity-0"
        }`}
      >
        Enter The Battlefield
      </h2>
      <br></br>
      <br></br>
            <br></br>
      <br></br>
      <p className="text-xl md:text-2xl leading-8 md:leading-9 text-gray-300 drop-shadow-[1px_2px_0px_black]">
        Eon Beasts are ancient creatures from distant worlds, scattered across the vastness of the universe. Eons ago, they lived on planets where civilizations rose and fell, each adapting to the ever-changing landscape of technological evolution.
      </p>
      <br></br>
      <p className="text-xl md:text-2xl leading-8 md:leading-9 text-gray-300 drop-shadow-[1px_2px_0px_black]">
        Unlike any other beings, these Beasts experienced the growth of entire cultures through their own unique evolutionary paths, some thriving with primitive fire, others advancing into technological power that can distort reality itself.
      </p>
      <button
        className="animated-button py-4 px-6 rounded bg-yellow-300 mt-4 hover:bg-yellow-400 text-black"
        onClick={() => (window.location.href = urlConfig.lore)}
      >
        Tales of the Lore
        <i className="pi pi-objects-column ml-4"></i>
      </button>
    </div>
  </div>
</div>

      {/* How It Works Section */}
      <div
        className="py-16 px-6 text-white relative"
        style={{
          backgroundImage: "linear-gradient(to bottom, #1a1a2e, #221721)",
        }}
      >
        <div className="max-w-6xl mx-auto">
          <h2
            ref={ref3}
            className={`animate-title-move text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-8 text-center sm:drop-shadow-[5px_8px_0px_black] drop-shadow-[3px_5px_0px_black] ${
              isVisible3 ? " animate-title-move opacity-100" : " opacity-0"
            }`}
          >
            Completely AI Powered
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Step 1 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-center flex flex-col justify-between" style={{backgroundColor:'#1b2535'}} >
              <div>
                <h3 className="text-2xl font-bold mb-4 drop-shadow-[1px_2px_0px_black]">
                  Unique Creativity
                </h3>
                <p className="text-gray-300 drop-shadow-[1px_1px_0px_black]">
                  Every asset is fully AI-generated. Advanced AI agents ensure each NFT is
                  truly one of a kind, with no duplicates.
                </p>
              </div>
              <div className="mt-6">
<img
  src={mintImage}
  alt="AI-Generated Creativity Icon"
  className="
    h-24 w-24
    sm:h-28 sm:w-28
    md:h-32 md:w-32
    lg:h-36 lg:w-36
    xl:h-40 xl:w-40
    mx-auto
  "
/>

              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-center flex flex-col justify-between" style={{backgroundColor:'#1b2535'}}>
              <div>
                <h3 className="text-2xl font-bold mb-4 drop-shadow-[1px_2px_0px_black]">
                  Interact
                </h3>
                <p className="text-gray-300 drop-shadow-[1px_1px_0px_black]">
                  Talk directly to your NFT using AI. Build a deeper bond as your beast
                  develops its own dialogue, memory, and personality.
                </p>
              </div>
              <div className="mt-6">
                <img
                  src={brainIcon}
                  alt="AI Interaction Icon"
  className="
    h-24 w-24
    sm:h-28 sm:w-28
    md:h-32 md:w-32
    lg:h-36 lg:w-36
    xl:h-40 xl:w-40
    mx-auto
  "
                />
              </div>
            </div>

            {/* Step 3 */}
            <div className=" p-6 rounded-lg shadow-lg text-center flex flex-col justify-between" style={{backgroundColor:'#1b2535'}}>
              <div>
                <h3 className="text-2xl font-bold mb-4 drop-shadow-[1px_2px_0px_black]">
                  Animate
                </h3>
                <p className="text-gray-300 drop-shadow-[1px_1px_0px_black]">
                  Bring your assets to life using tokens. Your NFTs evolve beyond static
                  images, unlocking powerful animations and effects for your journey.
                </p>
              </div>
              <div className="mt-6">
                <img
                  src={eonBeastsIconMoving}
                  alt="Animate NFT Icon"
  className="
    h-24 w-24
    sm:h-28 sm:w-28
    md:h-32 md:w-32
    lg:h-36 lg:w-36
    xl:h-40 xl:w-40
    mx-auto
  "
                />
              </div>
            </div>

            {/* Step 4 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg text-center flex flex-col justify-between" style={{backgroundColor:'#1b2535'}}>
              <div>
                <h3 className="text-2xl font-bold mb-4 drop-shadow-[1px_2px_0px_black]">
                  Buy, Sell, and Trade
                </h3>
                <p className="text-gray-300 drop-shadow-[1px_1px_0px_black]">
                  Trade your AI-powered NFTs on the marketplace. Discover rare creations or
                  sell highly trained champions in a thriving ecosystem.
                </p>
              </div>
              <div className="mt-6">
                <img
                  src={marketplaceImage}
                  alt="Marketplace Icon"
  className="
    h-24 w-24
    sm:h-28 sm:w-28
    md:h-32 md:w-32
    lg:h-36 lg:w-36
    xl:h-40 xl:w-40
    mx-auto
  "
                />
              </div>
            </div>
          </div>

        </div>
      </div>

      <div
        style={{ backgroundColor: "#221621", position: "relative" }}
        className="text-white py-16 px-6"
      >
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold mb-6 text-center drop-shadow-[1px_2px_0px_black]">
            Experience the Next Chapter of NFTs
          </h2>
          <p className="text-lg text-gray-300 text-center leading-7 mb-8 drop-shadow-[1px_1px_0px_black]">
            Dive into a world where AI and NFTs converge. With each evolution,
            your collection becomes more valuable.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col md:flex-row items-center md:items-start h-full" style={{backgroundColor:'#1b2535'}}>
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-4 drop-shadow-[1px_2px_0px_black]">Hyper Evolution</h3>
                <p className="text-gray-300 drop-shadow-[1px_1px_0px_black]">
                  Evolve your NFTs using high-quality AI Generated animations.
                </p>
              </div>
              <div className="mt-4 md:mt-0 md:ml-6">
                <img
                  src={evolutionImage}
                  alt="Living Animated NFTs"
  className="
    h-24 w-24
    sm:h-28 sm:w-28
    md:h-32 md:w-32
    lg:h-36 lg:w-36
    xl:h-40 xl:w-40
    mx-auto
  "
                />
              </div>
            </div>


            {/* Feature 2 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col md:flex-row items-center md:items-start h-full">
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-4 drop-shadow-[1px_3px_0px_black]">Global Leaderboard</h3>
                <p className="text-gray-300 drop-shadow-[1px_2px_0px_black]">
                  Be a top beast collector to get rewards.
                </p>
              </div>
              <div className="mt-4 md:mt-0 md:ml-6">
                <img
                  src={trophyImage}
                  alt="Global Leaderboard"
  className="
    h-24 w-24
    sm:h-28 sm:w-28
    md:h-32 md:w-32
    lg:h-36 lg:w-36
    xl:h-40 xl:w-40
    mx-auto
  "
                />
              </div>
            </div>

                        {/* Feature 3 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col md:flex-row items-center md:items-start h-full" style={{backgroundColor:'#1f2637'}}>
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-4 drop-shadow-[1px_3px_0px_black]">Exclusive Drops</h3>
                <p className="text-gray-300 drop-shadow-[1px_2px_0px_black]">
                  Be the first to own rare items, equipped with powerful animations.
                </p>
              </div>
              <div className="mt-4 md:mt-0 md:ml-6">
                <img
                  src={rareSword}
                  alt="Exclusive Drops"
  className="
    h-24 w-24
    sm:h-28 sm:w-28
    md:h-32 md:w-32
    lg:h-36 lg:w-36
    xl:h-40 xl:w-40
    mx-auto
  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div
        className="py-16 px-6 text-gray-800"
        style={{ backgroundColor: "#06b6d4" }}
      >
        <div className="max-w-6xl mx-auto text-center mb-10">
          <h2
            ref={ref2}
            className={`text-4xl font-bold mb-4 text-white drop-shadow-[2px_2px_0px_black] ${
              isVisible2 ? "animate-title-move opacity-100" : "opacity-0"
            }`}
          >
          Explore the Classes
          </h2>
          <p className="text-lg text-gray-100 drop-shadow-[1px_1px_0px_black]">
          Eon Beasts do not evolve in a single direction.
          Across distant worlds and forgotten timelines, each beast follows a unique evolutionary path shaped by its environment, conflicts, and technological discoveries.
          </p>
        </div>
        <Carousel
          value={models}
          itemTemplate={modelTemplate}
          numVisible={3}
          numScroll={1}
          responsiveOptions={responsiveOptions}
          className="custom-carousel"
          circular
          autoplayInterval={5024}
          showIndicators={false}
        />
      </div>

      <div className="flex flex-col md:flex-row">
        <div
          className="flex-1 text-white p-4 "
          style={{ backgroundColor: "#1a1a2e" }}
        >
          <div className="mt-4 text-center lg:ml-48 lg:mt-36 lg:text-justify">
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-8 drop-shadow-[1px_3px_0px_black]">
              Infinite Possibilities
            </h2>
            <p className="text-lg text-gray-300  leading-7 mt-8 text-2xl font-bold mb-4 drop-shadow-[1px_2px_0px_black]">
              Explore the Rarity of your NFTs
            </p>
          </div>
        </div>
        <div
          className="flex-1 bg-green-500 text-white p-4  "
          style={{ backgroundColor: "#1a1a2e" }}
        >
          <SpinningCard
            imageSrc={rarityImage}
            backImage={eonBeastWithBackground}
          />
        </div>
      </div>
      <div style={{ backgroundColor: "#1a1a2e" }}>
        <div className="text-center lg:ml-56 lg:text-justify">
        {grades.map((grade) => (
          <button
            key={grade.label}
            onClick={() => {
              setActiveGrade(grade.label);
              setRarityImage(grade.image);
            }}
            className={`mr-4 mt-4 px-4 py-2 bg-transparent transition-all duration-300 ${
              activeGrade === grade.label ? gradeClasses[grade.label] : "text-white"
            }`}
          >
            {grade.label}
          </button>
        ))}
        </div>
      </div>
        <div
          style={{ backgroundColor: "#1a1a2e" }}
          className=" h-36 sm:bottom-[-10%] w-full"
        ></div>
        <div
          className="grid grid-cols-1 md:grid-cols-2"
          style={{ backgroundColor: "#d6e6dd" }}
        >
          <div className="text-gray-800 p-4">
            <div className="mt-4 text-start lg:ml-48 lg:mt-36 lg:text-start">
              <div>
                <h2 className="text-5xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-8 dancing-text drop-shadow-[1px_2px_0px_white]">
                  Read The Docs
                </h2>
                <p className="text-justify sm:text-start mb-4 font-extrabold drop-shadow-[1px_1px_0px_white]">
                  Understand the Game
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
                  <img
                    src={readTheDocsImage}
                    alt="Read The Docs"
                    className="w-48 h-auto mx-auto sm:mx-0 order-1 sm:order-2"
                  />

                  <button className="animated-button py-2 px-6 rounded text-black bg-yellow-300 mt-8 hover:bg-yellow-400 text-white order-2 sm:order-1"
                    onClick={()=>{window.location.href = urlConfig.documentation}}
                  >
                    <i className="pi pi-book text-2xl"></i>
                    <span className="ml-2">Documentation</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="text-gray-800 p-4">
            <div className="mt-4 text-start lg:mr-48 lg:mt-36 lg:text-start">
              <div>
                <h2 className="text-5xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-8 drop-shadow-[1px_2px_0px_white] ">
                  Tokenomics
                </h2>
                <p className="text-justify sm:text-start mb-4 font-extrabold drop-shadow-[1px_1px_0px_white]">
                  See the token distribution
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
                  <img
                    src={tokenomics}
                    alt="Read The Docs"
                    className="w-48 h-auto mx-auto"
                  />

                  <button onClick={()=>setTokenomicsVisible(true)} className="animated-button py-2 px-6 rounded text-black bg-yellow-300 mt-8 hover:bg-yellow-400 text-white order-2 sm:order-1">
                    <i className="pi pi-dollar text-2xl"></i>
                    <span className="ml-2">Tokenomics</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ backgroundColor: "#d6e6dd" }}
          className=" sm:h-12 sm:bottom-[-10%] w-full"
        ></div>
        <div 
          style={{ backgroundColor: "#d6e6dd" }}>

          <div className="text-gray-800 p-4 lg:mr-48 lg:ml-48 " >
            <div className="mt-36 text-center ">
              <div>
                <h2 className="text-5xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-8">
                  Join the Battle for Solana 
                </h2>
                <p className="mb-4 font-extrabold text-center">
                  We believe that NFTs are not just static images. With Our development, NFTs can have more utilities and value by integrating AI and blockchain technology. 
                </p>
                <button onClick={()=>{setRoadmapVisible(true)}} className="animated-button py-2 px-6 rounded text-black bg-yellow-300 mt-8 hover:bg-yellow-400 text-white order-2 sm:order-1">
                    <i className="pi pi-sitemap text-2xl"></i>
                    <span className="ml-2">Roadmap</span>
                  </button>
                <img
                src={communityImage}
                className="w-full h-auto mx-auto"
                />
              </div>
            </div>
          </div>
          <footer style={{ backgroundColor: "#131220" }} className="text-white py-12">
  <div className="sm:w-[90%] mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col md:flex-row justify-between items-center gap-8">
      {/* Project Info */}
      <div className="mb-6 md:mb-0 text-center md:text-left">
        <h3 className="text-3xl font-bold">Eon Beasts</h3>
        <p className="mt-2 text-sm text-gray-400">
          Bridging AI and Digital Assets
        </p>
      </div>
      {/* Navigation Links */}
      <div className="flex flex-wrap justify-center space-x-6 mb-6 md:mb-0">
      <a
          href={urlConfig.aboutUs}
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-lg font-extrabold "
        >
          About Us
        </a>
      <a
          href={urlConfig.buyEon}
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-lg font-extrabold"
        >
          Buy $EON
        </a>
        <a
          href={urlConfig.documentation}
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-lg font-extrabold "
        >
          Docs
        </a>
        <a
          href={urlConfig.lore}
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-lg font-extrabold "
        >
          Lore
        </a>
        <a
          href={urlConfig.tokenomics}
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-lg font-extrabold"
        >
          Tokenomics
        </a>

        <a
          href={urlConfig.roadmap}
          className="cursor-pointer text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-lg font-extrabold"
        >
          Roadmap
        </a>
      </div>
      {/* Community Section */}
      <div className="flex flex-col items-center">
        <p className="mb-2 text-lg font-semibold">
          Join the Community
        </p>
        <div className="flex space-x-6">
          <a
            href={urlConfig.telegram}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#EF4E5D] transition duration-200"
          >
            <i className="pi pi-telegram text-3xl"></i>
          </a>
          <a
            href={urlConfig.twitter}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#EF4E5D] transition duration-200"
          >
            <i className="pi pi-twitter text-3xl"></i>
          </a>
        </div>
      </div>
    </div>
    <div className="flex justify-center space-x-4">
    <a
      href={urlConfig.termsAndConditions}
      rel="noopener noreferrer"
      className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-sm"
    >
      Terms & Conditions
    </a>
    <a
      href={urlConfig.privacyPolicy}
      rel="noopener noreferrer"
      className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-sm"
    >
      Privacy Policy
    </a>
  </div>
    <div className="mt-8 border-t border-gray-700 pt-4 text-center">
      <p className="text-sm text-gray-500">
        © {new Date().getFullYear()} Eon Beasts. All rights reserved.
      </p>
    </div>
  </div>
</footer>

        </div>
      </div>
      </>
  );
};

export default MainComponent;